<template>
  <div class="hero-item">
    <div class="hero-item-border">
      <div class="hero-item-wrap">
        <div class="hero-item-head">
          <div class="hero-item-head_bg"
               :style="{
              backgroundImage: `url(${heroItem.imagePath})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat' }"
          />
          <div class="hero-item-head_title" v-html="heroItem.name"/>
        </div>
      </div>
    </div>
    <div class="hero-item-body">
      <div class="hero-item-body_desc"
           v-html="heroItem.position"
      />
      <div class="hero-item-body_sticker" :class="{'show': heroItem.isHero, 'hide': !heroItem.isHero}">
        SPACE HERO
      </div>
      <ul class="hero-item-body_list">
        <li v-for="(li,i) in heroItem.list" :key="`{hero-li-${li}`" v-html="li"/>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroItem",
  props: {
    heroItem: {
      type: [Array, Object],
      default: {},
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-item {
  border-radius: 0 0 16px 16px;
  box-shadow: 0 4px 76px 0 rgba(0, 0, 0, 0.60);
  display: flex;
  flex-direction: column;
  height: 100%;

  .hero-item-border {
    border-radius: 14px;
    background: var(--bg-grad, linear-gradient(90deg, #2C11B4 0%, #B50E90 135.16%));
    box-shadow: 0 4px 76px 0 rgba(0, 0, 0, 0.60);
    padding: 2px;
  }

  .hero-item-wrap {
    background: #0D0D10;
    border-radius: 14px;
  }

  .hero-item-head {
    height: 310px;
    width: 100%;
    position: relative;
    display: flex;
    align-items: end;
    padding: 16px;

    @include _992 {
      padding: 20px 36px;
      height: 407px;
    }

    &:before {
      content: '';
      width: 100%;
      height: 70%;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(255, 255, 255, 0.1) 50%);
      border-radius: 0 0 14px 14px;
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 1;
    }

    &:after {
      content: '';
      width: 100%;
      height: 40%;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.50) 63.02%);
      border-radius: 0 0 14px 14px;
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 2;
    }

    .hero-item-head_bg {
      height: 110%;
      width: 100%;
      position: absolute;
      top: -10%;
      left: 0;
      z-index: 2;
      border-radius: 0 0 14px 14px;
    }

    .hero-item-head_title {
      position: relative;
      z-index: 5;
      font-family: Play, serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 128%; /* 35.84px */
      @include _992 {
        font-size: 28px;
      }
    }
  }

  .hero-item-body {
    background: linear-gradient(339deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.00) 21.35%, rgba(255, 255, 255, 0.00) 74.48%, rgba(255, 255, 255, 0.00) 100%), #0D0D10;
    padding: 12px 16px 24px 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
    border-radius: 0 0 14px 14px;

    @include _992 {
      padding: 16px 36px 36px 36px;
    }

    .hero-item-body_desc {
      color: var(--gray, #C7C7D1);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 146%; /* 20.44px */
      margin-bottom: 12px;
      flex-basis: 40px;
      @include _992 {
        margin-bottom: 16px;
      }
    }

    .hero-item-body_sticker {
      color: var(--white, #FFF);
      text-align: center;
      font-family: Play, serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 146%; /* 20.44px */
      display: flex;
      padding: 0 8px;
      justify-content: center;
      align-items: center;
      border-radius: 50px;
      background: var(--btn-normal, linear-gradient(92deg, #C0F -7.4%, #010BFE 102.31%));
      margin-right: auto;
      margin-bottom: 12px;
      @include _992 {
        margin-bottom: 28px;
      }
      &.hide {
        visibility: hidden;
      }
    }

    .hero-item-body_list {
      padding-left: 1rem;
      margin-bottom: 0;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 130%; /* 15.6px */
      @include _992 {
        font-size: 16px;
      }
    }
  }
}
</style>